/** Client-side helpers for promotion display (mirrors server promotion-display.ts). */

export function getPromotionTypeLabel(promotion: Record<string, unknown>): string {
  if (typeof promotion.type_label === 'string' && promotion.type_label.trim()) {
    return promotion.type_label;
  }

  if (promotion.redemption_type === 'COUPON' || promotion.code) {
    return 'Coupon';
  }

  const rules = promotion.rules;
  if (Array.isArray(rules) && rules.length > 0) {
    const action = (rules[0] as Record<string, unknown>).action as Record<string, unknown> | undefined;
    if (action?.fixed_price_set) {
      return 'Fixed price';
    }
    if (action?.cart_items) {
      return 'Cart items';
    }
    if (action?.shipping) {
      return 'Shipping';
    }
  }

  return 'Automatic';
}

/**
 * Return a promotion display name worth showing, or null when the value is
 * blank or a placeholder such as `-`, `---` or `—`.
 */
export function getMeaningfulDisplayName(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed || /^[-–—._\s]+$/.test(trimmed)) {
    return null;
  }

  return trimmed;
}

export function formatScheduleDate(dateString?: string | null): string {
  if (!dateString) {
    return 'Not set';
  }

  try {
    return new Date(dateString).toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return 'Not set';
  }
}
